import { render } from "./_Sidebar.vue?vue&type=template&id=b0f5df24&scoped=true"
import script from "./_Sidebar.vue?vue&type=script&lang=js"
export * from "./_Sidebar.vue?vue&type=script&lang=js"

import "./_Sidebar.vue?vue&type=style&index=0&id=b0f5df24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0f5df24"

export default script